export const roleUser = {
    admin: "ADMIN",
    user: "USER",
    backoffice: "BACKOFFICE"
}